import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-update-icon',
  templateUrl: './general-update.component.html'
})
export class GeneralUpdateComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
